import React from "react";
import { useDispatch } from "react-redux";

//Components
import { useLanguage } from "lang/Translate";

//css
import "./LanguageToggle.scoped.scss";

//icons
import pl from "assets/flags/pl.svg";
import gb from "assets/flags/gb.svg";

const LanguageToggle = ({ position = "left" }) => {
	const currLanguage = useLanguage();
	const dispatch = useDispatch();

	const handleLanguageChange = lang => {
		dispatch({ type: "LANGUAGE_SET", state: lang });
	};

	return (
		<div className={`container ${position}`}>
			<img
				src={pl}
				alt="Polski"
				className={currLanguage === "PL" ? "active" : ""}
				onClick={() => handleLanguageChange("PL")}
			/>
			<img
				src={gb}
				alt="English"
				className={currLanguage === "EN" ? "active" : ""}
				onClick={() => handleLanguageChange("EN")}
			/>
		</div>
	);
};

export default LanguageToggle;
